import React from 'react';
import { WindIcon, ShieldCheckIcon, LineChartIcon, ClockIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { BENEFITS, IMAGES, PRICING_ANCHOR, type Benefit } from '../data/content';
const ICONS: Record<Benefit['icon'], React.ElementType> = {
  stress: WindIcon,
  confidence: ShieldCheckIcon,
  progression: LineChartIcon,
  time: ClockIcon
};
export function Transformation() {
  return <section className="bg-charcoal py-10 sm:py-12" aria-labelledby="transformation-title" data-id="element-190" data-mp="11jf17gbindy2">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-8" data-id="element-191" data-mp="16adkmorsws5j">
        <SectionHeading title="What Changes When You Stop Starting From Scratch?" subtitle="A more organized way to plan, coach and progress your clients." data-id="element-192" data-mp="16c8561z5ui93" />

        <div className="mt-6 grid gap-4 lg:grid-cols-[0.85fr_1.15fr] lg:items-stretch lg:gap-6" data-id="element-193" data-mp="1fcmsf6voq7f8">
          <div className="relative overflow-hidden rounded-lg border border-line" data-id="element-194" data-mp="1ka65w4kk6g64">
            <img src={IMAGES.coachPlanning} alt="Functional training coach planning a session in a professional studio" className="h-44 w-full object-cover object-center sm:h-64 lg:h-full" data-id="element-195" data-mp="1c6tcmsd1hn83" />
            <div className="pointer-events-none absolute inset-0" style={{
            background: 'linear-gradient(180deg, rgba(12,12,13,0.1) 0%, rgba(12,12,13,0.82) 100%)'
          }} aria-hidden="true" data-id="element-196" data-mp="y68ulyey7vfn" />
            <p className="absolute bottom-3 left-3 right-3 font-display text-[17px] font-bold uppercase leading-[1.1] tracking-wide text-cream sm:text-2xl" data-id="element-197" data-mp="1qxadoalrib4g">
              Walk in with structure —{' '}
              <span className="text-gold" data-id="element-198" data-mp="1h3ac2ipovo0h">not a blank page.</span>
            </p>
          </div>

          <ul className="grid grid-cols-2 gap-3 lg:gap-4" data-id="element-199" data-mp="2embscfl6uii6">
            {BENEFITS.map(benefit => {
            const Icon = ICONS[benefit.icon];
            return <li key={benefit.title} className="flex h-full flex-col rounded-lg border border-line bg-panel p-3.5 sm:p-4" data-id="element-200" data-mp="2sqkf7h8exxp8">
                  <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-201" data-mp="2jwnve92q0xcz" />
                  <h3 className="mt-2 font-display text-[15px] font-bold uppercase leading-[1.1] tracking-wide text-cream sm:text-[18px]" data-id="element-202" data-mp="2nysnh3ditlxi">
                    {benefit.title}
                  </h3>
                  <p className="mt-1.5 text-[12px] leading-snug text-mutedtext sm:text-[13.5px]" data-id="element-203" data-mp="2ez5o0n4cqq73">
                    {benefit.body}
                  </p>
                </li>;
          })}
          </ul>
        </div>

        <div className="mx-auto mt-6 max-w-md" data-id="element-204" data-mp="2518060qemvf0">
          <CtaButton href={PRICING_ANCHOR} variant="outline" data-id="element-205" data-mp="3vcw28mp6quug">
            🚀 Get The Complete System
          </CtaButton>
        </div>
      </div>
    </section>;
}